import { useQuery } from "@tanstack/react-query";
import type { Sort } from "@unbox/api";
import { handleError } from "@/api/error";
import { type Pagination, toQuery } from "@/api/pagination";
import { client } from "../client";

export const useAdminMerchants = (
  pagination: Pagination,
  sort: Sort<"id" | "name" | "createdAt">,
  { text }: { text?: string },
) => {
  return useQuery({
    queryKey: ["admin", "merchants", pagination.limit, pagination.offset, sort.column, sort.direction, text],
    queryFn: async () => {
      const res = await client.admin.merchant.$get({
        query: {
          ...toQuery(pagination),
          ...sort,
          text,
        },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
